import { getKeyByValue } from '@latitude/core/helpers';
import { FONT_SIZE, LINE_HEIGHT } from '@latitude/core/utils/constants';
export const getLineHeight = (lineHeight, fontSize) => {
  const FONT_SIZE_KEY = getKeyByValue(FONT_SIZE, fontSize) || 'NORMAL';
  return lineHeight[FONT_SIZE_KEY];
};